/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "data": {
            "nested": {
              "MobileClientSourceDetails": {
                "fields": {
                  "source": {
                    "type": ".squareup.addons.data.MobileClientSourceDetails.Source",
                    "id": 1,
                    "rule": "optional"
                  },
                  "addonGroupId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Source": {
                    "values": {
                      "UNKNOWN_SOURCE": 0,
                      "ALL_ADDONS": 1,
                      "FOR_YOUR_BUSINESS": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.MobileClientSourceDetails && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.MobileClientSourceDetails?.nested?.Source) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE MobileClientSourceDetails @ squareup/addons/data/mobile_client_source_details.proto at 10:1
 */
export const MobileClientSourceDetails = $root.lookupType('squareup.addons.data.MobileClientSourceDetails');
fixType(MobileClientSourceDetails, {
  source: {
    required: true
  }
});
Builder.createAndAttachToType(MobileClientSourceDetails);
/**
 * SOURCE Source @ squareup/addons/data/mobile_client_source_details.proto at 11:3
 */
MobileClientSourceDetails.Source = $root.lookupEnum('squareup.addons.data.MobileClientSourceDetails.Source').values;